import { ReactNode } from "react";

export type GenericTableColumn<T> = {
  id: string;
  header: ReactNode;
  cell: (row: T) => ReactNode;
  headerClassName?: string;
  cellClassName?: string;
};

type GenericTableProps<T> = {
  columns: GenericTableColumn<T>[];
  rows: T[];
  rowKey: (row: T) => string;
  ariaLabel?: string;
  emptyState?: ReactNode;
};

function GenericTable<T>({
  columns,
  rows,
  rowKey,
  ariaLabel,
  emptyState,
}: GenericTableProps<T>) {
  return (
    <div className="tableWrap">
      <table className="companyTable" aria-label={ariaLabel}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th className={column.headerClassName} key={column.id}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && emptyState ? (
            <tr>
              <td colSpan={columns.length}>{emptyState}</td>
            </tr>
          ) : null}

          {rows.map((row) => (
            <tr key={rowKey(row)}>
              {columns.map((column) => (
                <td className={column.cellClassName} key={column.id}>
                  {column.cell(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default GenericTable;
